import React from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  Grid,
  Paper,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

// image imports
import cake from "./assets/BHIM,.png";
import burger from  "./assets/BHIM,.png";
import snacks from  "./assets/BHIM,.png";
import beverage from  "./assets/BHIM,.png";

const categories = [
  { label: "Cake", img: cake },
  { label: "Burger", img: burger },
  { label: "Snacks", img: snacks },
  { label: "Beverage", img: beverage },
];

// repeat items to fill screen like design
const categoryList = Array(1).fill(categories).flat();

export default function Categories() {
  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: "#f4f4f4" }}>
      {/* Header */}
      <AppBar
        position="static"
        sx={{ backgroundColor: "#FFE44D", boxShadow: "none" }}
      >
        <Toolbar>
          <IconButton edge="start">
            <ArrowBackIcon sx={{ color: "#000" }} />
          </IconButton>
          <Typography sx={{ color: "#000", fontWeight: 600 }}>
            Categories
          </Typography>
        </Toolbar>
      </AppBar>

      {/* Grid */}
      <Box sx={{ p: 2 }}>
        <Grid container spacing={2}>
          {categoryList.map((item, index) => (
            <Grid item xs={3} key={index}>
              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
              >
                <Paper
                  elevation={3}
                  sx={{
                    width: 70,
                    height: 70,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Box
                    component="img"
                    src={item.img}
                    alt={item.label}
                    sx={{
                      width: 40,
                      height: 40,
                      objectFit: "contain",
                    }}
                  />
                </Paper>

                <Typography
                  variant="body2"
                  sx={{ mt: 1, fontWeight: 500 }}
                >
                  {item.label}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}
